import { render, staticRenderFns } from "./buffet-plans.vue?vue&type=template&id=69e42587&scoped=true&"
import script from "./buffet-plans.vue?vue&type=script&lang=js&"
export * from "./buffet-plans.vue?vue&type=script&lang=js&"
import style0 from "./buffet-plans.vue?vue&type=style&index=0&id=69e42587&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e42587",
  null
  
)

export default component.exports